import { ReactElement } from 'react'
import InfoIcon from '@mui/icons-material/Info'
import { List, ListItem, Typography } from '@mui/material'
import { Box } from '@ui/structure'
import { StyledTooltip } from './styles'

interface Props extends TooltipContents {
  secondLineText?: string
  className?: string
  iconFontSize?: 'inherit' | 'large' | 'medium' | 'small'
  flex?: boolean
}

const InfoTooltip = ({
  text,
  secondLineText,
  headline,
  className = '',
  iconFontSize = 'small',
  flex = false,
}: Props): ReactElement => {
  return (
    <StyledTooltip
      title={
        <>
          {headline && <Typography variant="h6">{headline}</Typography>}
          <List>
            <ListItem>{<Typography variant="body2">{text}</Typography>}</ListItem>
            {secondLineText && (
              <ListItem>{<Typography variant="body2">{secondLineText}</Typography>}</ListItem>
            )}
          </List>
        </>
      }
      placement="right"
      className={className}
    >
      <Box
        sx={({ palette }) => ({
          color: palette.info.main,
          cursor: 'pointer',
          '& svg': {
            fontSize: 16,
          },
          ...(flex
            ? {
                display: 'flex',
              }
            : {}),
        })}
      >
        <InfoIcon fontSize={iconFontSize} />
      </Box>
    </StyledTooltip>
  )
}

export default InfoTooltip
